import { SET_COLUMN_DEF } from './actionTypes';

const setColumnDef = columnDefs => ({
    type: SET_COLUMN_DEF,
    payload: columnDefs,
});

export default setColumnDef;
